// Dependencies
import {
  useState,
  useEffect,
  useRef,
  useCallback,
  useContext,
  useMemo,
} from 'react'
import _ from 'lodash'

// Types
import { Types, Containers } from '../types'

// Hooks
import { useDebug, useWindowResize } from '../hooks'

// Components
import DesktopMenuVertical from '../components/DesktopMenuVertical'
import MobileMenu from '../components/MobileMenu'
import React from 'react'
import { Helpers } from '../utils'

// Types.MegamenuOptions
const Megamenu = ({loading, errors, ...props}: any) => {
  useDebug('Containers/Megamenu')
  //console.log(props);
  
  // Hooks
  const [underBreakpoint] = useWindowResize({cssAtts: true, breakpoint: props.config.general.mobileBreakpoint}) 

  const Menu = useMemo(
    () => ! underBreakpoint ? DesktopMenuVertical : MobileMenu,
    // () => ! underBreakpoint ? DesktopMenu : MobileMenu,
    [underBreakpoint],
  )

  return <Menu {...{...props}} />
}

export default Megamenu
 